import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';
import { EquipementMetadata } from "./equipementMetadata";
import { Equipement } from '../models/equipement';
import { User } from '../models/user';

@inheritSerialization(Entity)
export class CarnetEquipement extends Entity {

@deserializeAs(Equipement, 'equipement')
equipement

@deserializeAs(User, 'createur')
createur
}
